// libs
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// constants
import Routes from '@/constants/Routes';
const PublicRoutes = ({ isAuthenticated }) => {
    return (React.createElement(React.Fragment, null, !isAuthenticated ? (React.createElement(Outlet, null)) : (React.createElement(Navigate, { to: Routes.INSTAMART_HOME, replace: true }))));
};
export default PublicRoutes;
